// Dynamic permissions from the shared Mobile backend (Phase 2 RBAC).
// Fallback for servers that do not send `permissions` yet: legacy role → admin = everything, member = base only.
export const BASE = ["songs.view", "events.view", "setlists.view", "announcements.view", "attendance.own", "chat.own_room", "profile.edit"];

export function permissionsOf(user) {
  if (!user) return new Set();
  if (Array.isArray(user.permissions)) return new Set(user.permissions);
  return user.role === "admin" ? new Set(["*"]) : new Set(BASE);
}

export function can(user, ...perms) {
  const p = permissionsOf(user);
  return p.has("*") || perms.some((k) => p.has(k));
}

// Legacy `role: "admin"` is only kept for holders of the system Administrador profile (Phase 2 contract).
export const isSystemAdmin = (user) => user?.role === "admin" || !!user?.roles?.some((r) => r.system_key === "admin");

// Admin navigation: each entry visible with ANY of its permissions.
export const ADMIN_NAV = [
  { to: "/admin/members", label: "Membros", icon: "people", testid: "admin-members-link", perms: ["members.view", "members.manage"] },
  { to: "/admin/roles", label: "Perfis e permissões", icon: "key", testid: "admin-roles-link", perms: ["roles.manage"] },
  { to: "/admin/songs", label: "Gerir repertório", icon: "library", testid: "admin-songs-link", perms: ["songs.edit", "songs.delete", "audio.manage", "documents.manage"] },
  { to: "/admin/setlists", label: "Alinhamentos", icon: "list", testid: "admin-setlists-link", perms: ["setlists.edit", "setlists.delete"] },
  { to: "/admin/events", label: "Agenda", icon: "calendar-check", testid: "admin-events-link", perms: ["events.edit", "events.delete"] },
  { to: "/admin/announcements", label: "Alertas", icon: "megaphone", testid: "admin-announcements-link", perms: ["announcements.manage"] },
  { to: "/admin/attendance", label: "Assiduidade", icon: "stats", testid: "admin-attendance-link", perms: ["attendance.view_all"] },
];

export const adminNavFor = (user) => ADMIN_NAV.filter((n) => can(user, ...n.perms));

export const AVAILABILITY_PERMS = ["unavailability.view_status", "attendance.view_all"];
export const canSeeAvailability = (user) => can(user, ...AVAILABILITY_PERMS);

export const roleLabel = (user) =>
  user?.roles?.length ? user.roles.map((r) => r.name).join(" · ").toUpperCase() : user?.role === "admin" ? "ADMINISTRADOR" : "CANTOR";
